import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

export default function RequireAdmin({ children }) {
  const { user, status } = useAuthStore();

  // Same "wait for the session bootstrap" reasoning as RequireAuth.jsx.
  if (status === 'loading') return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}
